import React from "react";
import {ReactComponent as KeyLock} from '../../assets/keylock.svg';
import {makeStyles} from "@material-ui/core";
import {Colors} from "../../styles/Colors";


export const useStyles = makeStyles(() => ({
    root: {
        background: Colors.LightGraySecondary6,
        color: Colors.Text3,
        padding: '12px 20px' ,
        alignItems: "center",
        gap:8,
        display: "flex",
        lineHeight: '20px',
        fontSize: 14,
        fontWeight: 400,
        width: "fit-content",
        borderRadius: '4px',
        marginBottom:10
    },
    title: {
        fontWeight: 700,

    },
    subPageIcon: {
        marginTop: 3
    },

}));
const UnifiedAccessDenied: React.FC<{ title: string }> = ({title, children}) => {

    const classes = useStyles();
    return (
        <div className={classes.root}>
            <span><KeyLock className={classes.subPageIcon}/></span>
            <span className={classes.title}>{title}</span>
            {children}
        </div>
    )
}

export default UnifiedAccessDenied